export default "__VITE_ASSET__DkwG2GzR__"